<template>
  <div>
    <PageHeader title="Claim Invoices" />
    <ClaimInvoices claim-details-route-prefix="/admin/claims" />
  </div>
</template>

<script>
import { PageHeader } from "@estaly/ui";
import ClaimInvoices from "@/components/billing/claim_invoice/ClaimInvoices.vue";

export default {
  components: {
    ClaimInvoices,
    PageHeader,
  },
};
</script>
